// Ids match the seed in prisma/migrations/20260921120100_events_core_columns/migration.sql.
export var CalEventStatus;
(function (CalEventStatus) {
    CalEventStatus[CalEventStatus["SCHEDULED"] = 1] = "SCHEDULED";
    CalEventStatus[CalEventStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    CalEventStatus[CalEventStatus["UNDER_REVIEW"] = 3] = "UNDER_REVIEW";
    CalEventStatus[CalEventStatus["COMPLETED"] = 4] = "COMPLETED";
    CalEventStatus[CalEventStatus["CANCELLED"] = 5] = "CANCELLED";
})(CalEventStatus || (CalEventStatus = {}));
//# sourceMappingURL=cal-event-status.js.map